import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import PayInstIntro from './components/liabilityPolicy/payInstallment/PayInstIntro';
import PayInstMain from './components/liabilityPolicy/payInstallment/PayInstMain';
import PayInstDelivery from './components/liabilityPolicy/payInstallment/PayInstDelivery';
import PayInstSummary from './components/liabilityPolicy/payInstallment/PayInstSummary';
import PayInstConDelivery from './components/liabilityPolicy/payInstallment/PayInstConDelivery';
import PayInstConDSuccess from './components/liabilityPolicy/payInstallment/PayInstConDSuccess';
import PayInstWithCard from './components/liabilityPolicy/payInstallment/PayInstWithCard';
import PayInstWithCardSuccess from './components/liabilityPolicy/payInstallment/PayInstWithCardSuccess';

let PayInstallment = () => {

  const history = useHistory();
  const { insuranceId } = useParams();

  const {myPolicies} = useSelector(state=>state.userDetails);

  const [step, setStep] = useState(1);
  const [stepBack, setStepBack] = useState(null);
  const [showFade, setShowFade] = useState(true);

  const [policy, setPolicy] = useState(null);
  const [cashflowId, setCashflowId] = useState(null);

  //when redirected from my policy
  useEffect(() => {
    if(insuranceId && !policy && step === 1) {
      if(myPolicies && myPolicies.length) {
        const policy = myPolicies.find(obj=>obj.insuranceId === parseInt(insuranceId));
        setPolicy(policy);
        setStep(3);
      }
    }
  }, [insuranceId, policy, step, myPolicies]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const onBack = (toStep) => {
      toStep = stepBack ? stepBack : toStep;
      setShowFade(false);

      if(insuranceId && toStep === 2) {
        history.goBack();
      }

      setTimeout(() => {
        setStep(toStep);
        setStepBack(null);
        setShowFade(true);
      }, 0);
  }

  const onForward = (toStep, backTo, newPolicy, cashflowId) => {
      backTo ? setStepBack(backTo) : setStepBack(false);
      setShowFade(false);

      if(toStep === 3) {
        setPolicy(newPolicy);
      }

      if(toStep === 4) {
        setCashflowId(cashflowId);
      }

      setTimeout(() => {
        setStep(toStep);
        setShowFade(true);
      }, 0);
      
  }

  const renderStepScreen = () => {
      switch (step) {
          case 1:
            return <PayInstIntro onForward={onForward}/>;
          case 2:
            return <PayInstMain onBack={onBack} onForward={onForward} />;
          case 3:
            return <PayInstDelivery onBack={onBack} onForward={onForward} policy={policy} />;
          case 4:
            return <PayInstSummary onBack={onBack} onForward={onForward} policy={policy} />;
          case 5:
            return <PayInstWithCard onBack={onBack} onForward={onForward} policy={policy} />;
          case 6:
            return <PayInstWithCardSuccess onBack={onBack} onForward={onForward} policy={policy} cashflowId={cashflowId} />;

          case 7:
            return <PayInstConDelivery onBack={onBack} onForward={onForward} policy={policy} />;
          case 8:
            return <PayInstConDSuccess onBack={onBack} onForward={onForward} policy={policy} cashflowId={cashflowId} />;

          default:
            return <div></div>;
      }
  }

  return (
      <div style={{position: 'realtive'}}>
          <Fade in={showFade} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
            {renderStepScreen()}
          </Fade>
      </div>
  )
}

export default PayInstallment;